import React from 'react'
import SearchLink from '../../containers/searchLinkContainer'

const DidYouMeanBy = ({ locationParams, didYouMeanByTerms, styles }) => {
  return (
    <p className={styles.didYouMeanText}>
      <strong>{'Did you mean: '}</strong>
      {didYouMeanByTerms.map((term, index) => {
        const nextQuery = Object.assign({}, locationParams, {
          term
        })
        return (
          <span key={index}>
            <SearchLink
              locationParams={nextQuery}
              className={styles.didYouMeanLink}
            >
              {term}
            </SearchLink>
            {index < didYouMeanByTerms.length - 1 ? ', ' : null}
          </span>
        )
      })}?
    </p>
  )
}

export default DidYouMeanBy
